module.exports = __webpack_public_path__ + "static/img_7.074df6f1.jpg";